import { createScaffolderFieldExtension } from '@backstage/plugin-scaffolder-react';
import { scaffolderPlugin } from '@backstage/plugin-scaffolder';
import { ConditionalGitRefField } from './ConditionalGitRefField';
import { ConditionalEnvironmentField } from './ConditionalEnvironmentField';
import { BulkAgentSelectorField } from './BulkAgentSelectorField';
import { BulkWorkspaceIdsField } from './BulkWorkspaceIdsField';
import { AgentNameField } from './AgentNameField';
import { PerEnvFieldsField } from './PerEnvFieldsField';
import { EnvVarsField } from './EnvVarsEditor';
import { ResourcesField } from './ResourcesEditor';


// --- Deploy Agent templates (eng-template.yaml, non-eng-template.yaml, bulk-template.yaml) ---

export const ConditionalGitRefFieldExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'ConditionalGitRef',
    component: ConditionalGitRefField,
  })
);

export const ConditionalEnvironmentFieldExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'ConditionalEnvironment',
    component: ConditionalEnvironmentField,
  })
);

export const BulkAgentSelectorFieldExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'BulkAgentSelector',
    component: BulkAgentSelectorField,
  })
);

export const BulkWorkspaceIdsFieldExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'BulkWorkspaceIds',
    component: BulkWorkspaceIdsField,
  })
);

// --- Create Agent template (create-agent/template.yaml) ---

export const AgentNameFieldExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'AgentName',
    component: AgentNameField,
  })
);

// --- API Server template (api-server-template.yaml) ---
export const PerEnvFieldsFieldExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'PerEnvFields',
    component: PerEnvFieldsField,
  }),
);

export const EnvVarsFieldExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'EnvVars',
    component: EnvVarsField,
  }),
);

export const ResourcesFieldExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'Resources',
    component: ResourcesField,
  }),
);
